import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure
} from '@chakra-ui/react'
import { useSettings } from '../../hooks'
import { useCallback, useEffect } from 'react'
import styles from './terms-and-conditions.module.css'
import { SettingActions } from '../../store/slices/settings'
import { useDispatch } from '../../store'

export const TermsAndConditions = () => {
  const { isOpen, onOpen, onClose } = useDisclosure({})
  const { acceptedTerms, acceptTerms } = useSettings()
  const dispatch = useDispatch()

  useEffect(() => {
    const accepted = Boolean(localStorage.getItem('acceptedTerms'))
    if (accepted) {
      dispatch(SettingActions.acceptTerms())
    }
  }, [dispatch])

  useEffect(() => {
    if (!acceptedTerms) {
      onOpen()
    }
  }, [acceptedTerms, onOpen])

  const closeModal = useCallback(() => {
    onClose()
    acceptTerms()
  }, [acceptTerms, onClose])

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>We are happy to see you 😊</ModalHeader>
        

        <ModalCloseButton />
        <ModalBody fontSize="sm">
          <div className={styles.root}>
            <div>
              <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '12px' }}>
                Get Started with Team TimeZone
              </h3>
            </div>
            
            <div style={{ marginBottom: '16px' }}>
              <p style={{ fontWeight: 500, marginBottom: '8px' }}>
                1. Auto time conversions - never do timezone math again:
              </p>
              <code style={{ display: 'block', fontFamily: 'monospace', backgroundColor: '#f5f5f5', padding: '6px 8px', borderRadius: '4px', fontSize: '13px' }}>
                /invite @Team TimeZone
              </code>
              <p style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                Type this in any Slack channel. Each teammate sees times in their local timezone privately
              </p>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <p style={{ fontWeight: 500, marginBottom: '8px' }}>
                2. Find perfect meeting windows instantly:
              </p>
              <code style={{ display: 'block', fontFamily: 'monospace', backgroundColor: '#f5f5f5', padding: '6px 8px', borderRadius: '4px', fontSize: '13px' }}>
                /ttz find best time @teammate1 @teammate2
              </code>
              <p style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                Use anywhere in Slack. Get suggested times that work across everyone's timezones
              </p>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <p>
                <strong>That's it! 🎉</strong> Now you can explore the dashboards to see your team at a glance and help with coordination.
              </p>
            </div>

            <div style={{ fontSize: '10px', color: '#666', borderTop: '1px solid #eee', paddingTop: '12px' }}>
              <p>
                By using this application, you agree to our <Link color="teal" href="https://www.teamtimezone.com/terms.html" target="_blank">Terms of Service</Link> and <Link color="teal" href="https://www.teamtimezone.com/privacypolicy.html" target="_blank">Privacy Policy</Link>. We comply with GDPR for your privacy protection.
              </p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={closeModal} backgroundColor="#4ebcd3">
            Let's start
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
